import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { debounceTime, map, take, retry } from 'rxjs/operators';
import { Http } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
//This Should not be modified without discuss with Dheeraj
@Injectable({ providedIn: 'root' })
export class ManikEntityService {
  myAppUrl: any = location.origin + "/";

  private DataPassed = new BehaviorSubject(undefined);
  private InitializeEdit = new BehaviorSubject(undefined);
  Data = this.DataPassed.asObservable();
  ReInitializeEdit = this.InitializeEdit.asObservable();
  public uploadURL = '#SAVEPATH#/#FILENAME#.';
  constructor(public _httpClient: HttpClient, @Inject(DOCUMENT) public document: any, private _http: Http, private _activatedRoute: ActivatedRoute) {
    //this.myAppUrl = this.document.baseURI;
  }

  setData(data: any) {
    console.log(data)
    this.DataPassed.next(data);
  }

  reInitializeEdit(data: boolean) {
    this.InitializeEdit.next(data);
  }

  manikEntityConnect(route: string, body: any = null, header: any = null) {
    return this._httpClient.post<any>(this.myAppUrl + route, body, { headers: header })
      .pipe(map(value => value), take(1), retry(3));
  }
  manikEntityConnect2(route: string, body: any = null, header: any = null) {
    return this._httpClient.post<any>(route, body, { headers: header })
      .pipe(map(value => value), take(1), retry(3));
  }
  manikWebAPIConnect(url: string, body: any, header: any) {
    return this._httpClient.post(url, body, { headers: header }).pipe(map(value => value), take(1));
  }

  manikWebAPIConnectHttp(url: string, body: any, header: any) {
    return this._http.post(url, body, header).pipe(map(value => {
      let response: any = value;
      return JSON.parse(response._body);
    }), take(1));
  }

  manikFileUpload(uploadUrl: string, frmData: any, header: any) {
    return this._httpClient.post<any>(uploadUrl, frmData, { headers: header });
  }

  manikImageUpload(frmData: any, header: HttpHeaders) {
    return this._httpClient.post("https://imagehandler.manikworks.com/imageupload", frmData, { headers: header }).pipe(map(value => value), take(1));
    // return this._httpClient.post('http://localhost:58307'+"/imageupload", frmData, { headers: header }).pipe(map(value => value), take(1));
  }

  manikDocUpload(frmData: any, header: HttpHeaders) {
    return this._httpClient.post("http://imagehandler.manikworks.com/docupload", frmData, { headers: header }).pipe(map(value => value), take(1));
  }

  getFeebackFormData(data: any, header: HttpHeaders) {
    return this._httpClient.post("http://entityserver.manikworks.com/bizapp", data, { headers: header }).pipe(map(value => value), take(1));
  }

  manikAutoComplete(route: string, body: any, header: any) {
    return this._httpClient.post<any>(this.myAppUrl + route, body, { headers: header })
      .pipe(
        debounceTime(500),  // WAIT FOR 500 MILISECONDS ATER EACH KEY STROKE.
        map(
          (data: any) => {
            return (
              data.length != 0 ? data as any[] : [{ "DataText": "No Record Found" } as any]
            );
          }
        ));
  }
  manikAutoComplete2(route: string, body: any, header: any) {
    return this._httpClient.post<any>(route, body, { headers: header })
      .pipe(
        debounceTime(500),  // WAIT FOR 500 MILISECONDS ATER EACH KEY STROKE.
        map(
          (data: any) => {
            return (
              data.length != 0 ? data as any[] : [{ "DataText": "No Record Found" } as any]
            );
          }
        ));
  }
  manikWebAPIConnectGeneric(url: string, body: string, header: any, method: string) {
    switch (method) {
      case 'GET':
        return this._http.get(url, header).pipe(map(value => {
          let response: any = value;
          return JSON.parse(response._body);
        }), take(1));
      case 'POST':
        return this._httpClient.post<any>(url, body, { headers: header }).pipe(map(value => value), take(1), retry(2));
    }
  }

  manikWebAPIConnectGeneric2(url: string, body: string, header: any, method: string) {
    switch (method) {
      case 'GET':
        return this._http.get(url, header).pipe(map(value => {
          let response: any = value;
          return response._body;
        }), take(1));
      case 'POST':
        return this._httpClient.post<any>(url, body, { headers: header }).pipe(map(value => value), take(1), retry(2));
    }
  }
  manikGetMyIPAddress() {

    return this._httpClient.get<any>('http://api.ipify.org/?format=json').pipe(map(value => value.ip), take(1));
  }

  initializeApp(): any {
    // let slug: string = this._activatedRoute.snapshot.params['businessslug'];
    // this.manikEntityConnect("website/limitedtoken", null, null)
    //   .subscribe(token => {
    //     let headers = new HttpHeaders({
    //       'BusinessSlug': slug,
    //       'Context': "FETCH.MY.SITE",
    //       'Authorization': token.STATUS
    //     });

    //     return this.manikWebAPIConnect("http://sitefetch.manikworks.com/smartbiz", null, headers)
    //       .subscribe(data =>
    //         console.log(data));
    //   });
  }

  errorHandler(error: Response) {
    return Observable.throw(error);
  }
}
